"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultMintHeaders_1 = __importDefault(require("../../getDefaultMintHeaders"));
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
var pagination_1 = require("@fuze/apis-core/dist/pagination");
/**
 * Get the contracted products for an organization
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param organizationCode The organization code that all of the locations must belong to
 * @param pagination A PaginationRequest object used to filter the results
 */
function getContractedProducts(baseUrl, wardenToken, organizationCode, pagination) {
    if (organizationCode === void 0) { organizationCode = ""; }
    if (pagination === void 0) { pagination = pagination_1.defaultPaginationRequest; }
    var serializedPagination = (0, pagination_1.serializePagination)(pagination);
    return (0, http_client_1.default)({
        method: "GET",
        url: baseUrl + "/v1/contracts/organizations/" + organizationCode + "?" + serializedPagination,
        headers: __assign({}, (0, getDefaultMintHeaders_1.default)(wardenToken))
    }).then(function (response) { return response.data; });
}
exports.default = getContractedProducts;
